import moment from "moment";

import { CartItem } from "../../redux_store/cart/models";
import {
  GetOrderResponse,
  OrderResponse,
} from "../../services/api/order/model";
import { CheckoutResponse } from "../checkout/model";
import { ErrorResponse } from "../error/models";

export enum OrderChannel {
  WEB = 2,
  APP = 1,
}

export enum OrderType {
  STANDARD = 1,
  GROUP_ORDER = 2,
}

export enum CollectionType {
  PICK_UP = "PICKUP",
  TABLE_SERVICE = "TABLE",
  DRIVE_THRU = "DRIVETHRU",
}

export enum TableServiceType {
  MANUAL = "MANUAL",
  QR = "QR",
}

export enum GroupOrderType {
  SINLGE = "SINGLE",
  SPLIT = "SPLIT",
}

export interface OrderTimeSetup {
  pickupDay: moment.Moment;
  pickupHour: number;
  pickupMinute: number;
  pickupAmPm: boolean;
  pickupASAP: boolean;
}

export interface OrderCollectionTypeProps {
  orderCollectionType: CollectionType;
}

export interface SetupOrderProps {
  orderASAP: boolean;
  orderTime: number | null;
  orderCollectionType: CollectionType;
  tableNumber?: string;
  tableInit?: TableServiceType;
}
export interface GetOrderProps {
  sessionId: string;
}

export interface OrderState {
  sessionId?: string;
  //TimeStamp
  orderInitialTime: number;
  //TimeStamp
  orderTime: number | null;
  orderCollectionType: CollectionType;
  orderASAP: boolean;
  email: string;
  includeCutlery: boolean;
  tableNumber: string;
  driveThruOptionAvailable: boolean;
  getOrderLoading: boolean;
  getOrderByIdSuccess: boolean;
  getOrderError: ErrorResponse;
  updateOrderLoading: boolean;
  orderTimeUpdated: boolean;
  currentOrderId: string | null;
  guestOrderId: string | null;
  getOrderResponse: null | OrderResponse;
  userConfirmedOrderSetup: boolean;
  hasOrderPending: boolean;
  orderStatus: GetOrderResponse;
  currentOrders: CheckoutResponse[];
  recentOrders: CheckoutResponse[];
  tableInit: TableServiceType;
  showMoreAvailable: boolean;
  addToAccountLoading: boolean;
  addToAccountSuccess: boolean;
  generalError: string;
  getOrderByIdResponse: CheckoutResponse;
  getOrderByIdError: boolean;
  getAuthenticatedOrdersLoading: boolean;
  ratingOrder: RatedOrderProps;
  ignoreTimeChange: boolean;
  ratingValue: number | null;
}

export interface AddToAccountError {
  message: string;
  code: number;
}

export interface SetCurrentOrRecentOrders {
  currentOrRecentOrders: CheckoutResponse[];
  clearCurrentAndRecentOrders: boolean;
}

export interface Product {
  productId: number;
  name: string;
  quantity: number;
  price: number;
}

export interface StoreAddress {
  streetAddress: string;
  city: string;
  state: string;
  postcode: string;
  latitude: number;
  longitude: number;
}

export interface GetAuthenticatedOrdersPayload {
  offset?: number;
}

export interface RatedOrderProps {
  cartSize: number | undefined;
  cartAmount: number | undefined;
  storeName: string | undefined;
  storeId: string | undefined;
  orderNumber?: string;
  orderId: string | undefined;
  orderType: string | undefined;
  productImage?: string;
  numberOfOtherProducts?: number;
  highestPriceProduct?: CartItem;
}
